import React from "react";
// import { Button } from "../button/button";

import './hello.css';

export class Hello extends React.Component {
  render() {
    return (
      <div  className="hello">
        <div className="hello__header">ШКОЛА МИГРАНТА 2.0!</div>
        <div className="hello__text">
          <span>Навыковый тренинг в формате игры</span>
        </div>
      </div>
    );
  }
}
